<template>
  <v-card @click="goToTrip(trip.id)">
    <!--          :src="urls[trip.id] || require('@/assets/trip.jpg')"-->
    <v-img
      :src="urls[trip.id] || require('@/assets/trip.jpg')"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="400px"
    >
      <!--            <v-card-title v-text="trip.name"></v-card-title>-->

      <v-card class="mx-auto mt-0 mb-4 ml-3 mr-3" outlined color="rgb(255, 255, 255, 0.82)">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1 font-weight-bold">
              {{ trip.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ trip.description }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mt-2">
              <v-icon small color="primary">mdi-clock</v-icon>
              <span class="text--primary font-weight-bold">
                {{
                  $t("itinerary.dates", {
                    dates: `${$options.filters.zonedDate(trip.start_date, "P", "UTC")} -
                      ${$options.filters.zonedDate(trip.end_date, "P", "UTC")}`,
                  })
                }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions class="mr-2">
          <!-- <v-btn
                    outlined
                    text
                    small
                    width="50%"
                >
                  {{ $t('common.moreInfo') }}
                    width="50%"
                </v-btn> -->
          <v-btn depressed block small color="primary" @click="goToTrip(trip.id)">
            {{ $t("common.dashboard") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-img>
  </v-card>
</template>

<script>
export default {
  props: ["trip"],
  computed: {
    urls() {
      return this.$store.state.imageUrls;
    },
  },
  methods: {
    goToTrip(tripId) {
      this.$emit("goToTrip", tripId);
    },
  },
};
</script>
